<template>
  <button
    v-if="hasValue"
    type="button"
    class="tw-flex tw-cursor-pointer tw-items-center tw-text-primary-grey-700"
    v-tippy="{ content: label, placement: 'top' }"
    :aria-label="label"
    :data-test-id="testId"
    @click="onClick"
  >
    <cb-icon-copy />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useCopyToClipboard } from "@/composables/useCopyToClipboard";

const props = defineProps<{
  value: string | null | undefined;
  label: string;
  testId?: string;
}>();

const { copy } = useCopyToClipboard();

const hasValue = computed(
  () => typeof props.value === "string" && props.value.trim().length > 0,
);

const onClick = () => {
  if (props.value) copy(props.value);
};
</script>
